import _sfc_main from './blank.vue.js';
/* empty css           */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const Blank = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-fdef0fb9"]]);

export { Blank as default };
//# sourceMappingURL=blank.js.map
